import React from "react";

import { DownMinimalArrow } from "icons";

import {
  DropdownOverlay,
  Typography,
  Checkbox,
} from "clearsense-ui/components";

const ColumnSelect = ({ columns, toggleVisibility }) => (
  <DropdownOverlay
    buttonLabel="Edit Columns"
    buttonStyle="secondary"
    buttonProps={{ icon: DownMinimalArrow }}
  >
    <div className="m-4">
      <Typography style="h6" className="mb-2 uppercase text-grey-medium-shade">
        enabled
      </Typography>
      {columns?.selected?.map(column => (
        <Checkbox
          key={column.key}
          label={column.title}
          id={column.key}
          className="mb-5"
          onClick={e =>
            columns.selected.length > 1 && toggleVisibility(e.target.id)
          }
          disabled={columns.selected.length === 1}
          checked
          readOnly
        />
      ))}
    </div>

    <div className="m-4">
      <Typography style="h6" className="mb-2 uppercase text-grey-medium-shade">
        disabled
      </Typography>
      {columns.unSelected.map(column => (
        <Checkbox
          key={column.key}
          label={column.title}
          id={column.key}
          className="mb-5"
          onClick={e => toggleVisibility(e.target.id)}
          readOnly
        />
      ))}
    </div>
  </DropdownOverlay>
);

export default ColumnSelect;
